/* Project Import will be here */
import { getErrorObject } from "../../utilities/utils";
import { getQpsSchemeListApi } from "../../services/promotions";
/* Project Import will be here */

export const types = {
    QPS_SCHEMES_REQUEST: "qpsSchemes/qpsSchemesRequest",
    QPS_SCHEMES_SUCCESS: "qpsSchemes/qpsSchemesSuccess",
    QPS_SCHEMES_FAILURE: "qpsSchemes/qpsSchemesFailure",
};

const initialState = {
    data: [],
    isLoading: false,
    error: null
};

export const qpsSchemes = (state = initialState, action) => {
    switch (action.type) {
        case types.QPS_SCHEMES_REQUEST:
            return { ...state, isLoading: true };
        case types.QPS_SCHEMES_SUCCESS:
            return { ...state, ...action.payload, error: null, isLoading: false };
        case types.QPS_SCHEMES_FAILURE:
            return { ...state, isLoading: false, error: action.payload.error };
        default:
            return state;
    }
};

/* Get QPS scheme list to render the schemes in list page */
export const getQpsSchemes = () => {
    return async (dispatch, getState) => {
        dispatch({ type: types.QPS_SCHEMES_REQUEST });

        try {
            const response = await getQpsSchemeListApi();

            dispatch({
                type: types.QPS_SCHEMES_SUCCESS,
                payload: { data: response.data.Data }
            });
        }
        catch (error) {
            const { message } = getErrorObject(error);
            dispatch({
                type: types.QPS_SCHEMES_FAILURE,
                payload: { error: message }
            });
        }
    }
};